export const cookieNames = {
  auth: "testaviva_app",
} as const;
